import { LightbulbCflSpiralIcon } from './LightbulbCflSpiralIcon';

/**
 * author: undearius
 * id 0F61D2EB-5321-4D49-B9DD-4F205DA010A2
 * name lightbulb-cfl-spiral
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-cfl-spiral.svg
 * tags
 * - Home Automation 
 */
export const BulbCflSpiralIcon = LightbulbCflSpiralIcon;
export default BulbCflSpiralIcon